export default __webpack_public_path__ + "static/media/dogphone.5eca19ab.jpg";